// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isGetEngagementAppGroupIdSurveysSurveyStatsSummaryResult = objectOf({
  active_surveys: number,
  total_surveys: number,
  total_responses: number,
});
